var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.8286 3.75732L12.2428 5.17154L5.17176 12.2426L3.75755 10.8284L10.8286 3.75732Z","key":0}),React.createElement("path",{"d":"M12.2427 10.8285L10.8285 12.2427L3.7574 5.17164L5.17161 3.75742L12.2427 10.8285Z","key":1})]);
}

IconClose.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"currentColor"};

module.exports = IconClose;

IconClose.default = IconClose;
